import { FullStory } from '@fullstory/browser'
import { NETLIFY_FUNCTIONS_PATH } from '../constants'

export class GetEmailTemplate {
    static customQuoteEmailTemplate = (name, city) => {
        return `<html>
      <head>
      <title>Milan Laser Estimate</title>
      <style>
      
      </style>
      </head>
      <body >
      <p>Hello ${name}, </p>
      <p>Thank you for contacting Milan Laser for your custom quote! We'll be reaching out to you soon.
      Have another question? Just reply to this email and we'll get back to you.</p>
      
      <p>We look forward to helping you never shave again!</p>
      
      
      <p>Thanks again!
      <br>The Milan Laser ${city} Team
      <br>1-833-NO-RAZOR<br>
      <a href="https://milanlaser.com">milanLaser.com</a>
      </p>
      </body>
      </html>`
    }
}
// utility function to send email using Netlify function
export async function handleSendEmail(to, subject, htmlTemplate, source) {
    try {
        const response = await fetch(`${NETLIFY_FUNCTIONS_PATH}sendEmail`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ to, subject, htmlTemplate }),
        })

        const result = await response.json()

        if (!response.ok) {
            // Even if the response contains JSON, it's still an error
            throw new Error(
                `Failed to send email: ${
                    result.error || result.details || 'Unknown error'
                }`
            )
        }

        //   console.log('Email sent successfully:', result)

        // FullStory Event Tracking
        FullStory('trackEvent', {
            name: 'Email Sent',
            properties: {
                name: 'Email Sent Successfully',
                value: {
                    source: source,
                    recipient: to,
                    subject: subject,
                },
                result: result,
            },
        })

        return result
    } catch (error) {
        console.error('Error sending email:', {
            message: error.message,
            stack: error.stack,
            name: error.name,
        })

        // FullStory Event Tracking
        FullStory('trackEvent', {
            name: 'Unable to send email',
            properties: {
                name: 'Failed Sending Email',
                value: {
                    errorMessage: error.message,
                    email: to,
                    source: source,
                },
            },
        })

        // Re-throw the error so the caller can handle it
        throw error
    }
}
